module.exports = __webpack_public_path__ + "img/icon_firebase.ae2023f3.png";